module.exports = __webpack_public_path__ + "assets/img/client-logo-cpac-mono.97032245.png";